import { theme as defaultTheme } from "@mindlercare/ui-web";
import { css } from "styled-components";

export const MUIOverrides = css`
  .MuiTooltip-tooltip {
    font-size: ${(p) => defaultTheme.FONT.SIZE.SMALL};
  }

  .MuiIconButton-colorSecondary:hover {
    background-color: ${(p) => defaultTheme.COLORS.RIPPLE};

    &:hover {
      background-color: ${(p) => defaultTheme.COLORS.RIPPLE};
    }
  }

  .MuiTouchRipple-root {
    color: ${(p) => defaultTheme.COLORS.GRAY_BLACK};
  }

  .MuiSvgIcon-colorSecondary {
    color: ${(p) => defaultTheme.COLORS.GRAY_BLACK};
  }

  .MuiSwitch-switchBase {
    top: 0;
    left: 0;
    color: #fafafa;
    z-index: 1;
    position: absolute;
    transition:
      left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    padding: 9px;
  }

  .Mui-checked {
    .MuiSwitch-thumb {
      background-color: #ffff;
    }
  }

  .MuiSwitch-thumb {
    background-color: ${(p) => defaultTheme.COLORS.WHITE};
  }

  @media (min-width: 600px) {
    .MuiTab-root {
      min-width: auto;
    }
  }

  .MuiRadio-colorSecondary.Mui-checked {
    color: ${(p) => defaultTheme.COLORS.GRAY_BLACK};
  }

  .MuiFormLabel-root {
    font-family: ${defaultTheme.FONT.FAMILY.BODY};
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    color: ${defaultTheme.COLORS.GRAY_DARK};
    &.Mui-focused {
      color: ${defaultTheme.COLORS.GRAY_DARK};
    }
  }

  .MuiFormControlLabel-root {
    margin-right: 32px;
  }

  .MuiFormLabel-root.Mui-error {
    color: ${defaultTheme.COLORS.ERROR};
  }
`;

export const reactPhoneInputOverrides = css`
  .react-tel-input {
    .country-name,
    .dial-code {
      font-family: "Inter";
    }
    .special-label {
      display: none;
    }

    .form-control {
      font-family: ${defaultTheme.FONT.FAMILY.BODY};
      font-size: 16px;
      border-color: ${defaultTheme.COLORS.GRAY_MEDIUM};
      color: ${defaultTheme.COLORS.GRAY_BLACK};
      height: 48px;
      background-color: transparent;
      border-radius: 4px;
      padding-left: 80px;
      &.open {
        border-color: ${defaultTheme.COLORS.GRAY};
      }
      &:disabled {
        background-color: ${defaultTheme.COLORS.WHITE};
      }
      &:focus,
      &:active {
        border-color: ${defaultTheme.COLORS.GRAY};
      }
    }

    &.error {
      .form-control {
        border-color: ${defaultTheme.COLORS.ERROR};
      }

      .selected-flag {
        border-color: ${defaultTheme.COLORS.ERROR} !important;
      }
    }

    .flag-dropdown {
      height: 100%;
      border: none;
      background-color: transparent !important;
      .open {
        background: transparent !important;
        .selected-flag {
          background: transparent !important;
        }
      }
    }

    .selected-flag {
      width: 70px;
      padding-left: 16px;
      justify-content: center;
      border-right: 1px solid ${defaultTheme.COLORS.GRAY_MEDIUM};
      background-color: transparent !important;
      &.open {
        border-color: ${defaultTheme.COLORS.GRAY};
      }
      &:hover {
        background-color: transparent;
      }
      .arrow {
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid ${defaultTheme.COLORS.GRAY_BLACK};
        left: 26px;
      }
    }
  }

  .MuiSnackbar-anchorOriginTopCenter {
    top: 72px;
  }
`;
